// extracted by mini-css-extract-plugin
export default {"WrapperLissensIndex":"EditThemeTest_WrapperLissensIndex__jHkM-"};